import axios from 'axios';
export class PortalsError extends Error {
    constructor(message) {
        super(message);
        this.name = 'PortalsError';
    }
}
export const fetchPortalsTradeOrder = async ({ sender, inputToken, inputAmount, outputToken, slippageTolerancePercentage, autoSlippage, partner, feePercentage, validate, swapperConfig, }) => {
    const url = `${swapperConfig.VITE_PORTALS_BASE_URL}/v2/portal`;
    const params = new URLSearchParams({
        partner,
        ...(sender ? { sender } : {}),
        inputToken,
        inputAmount,
        outputToken,
        validate: validate.toString(),
    });
    if (!autoSlippage) {
        params.append('slippageTolerancePercentage', slippageTolerancePercentage.toFixed(2)); // Portals API expects a string with at most 2 decimal places
    }
    if (feePercentage) {
        params.append('feePercentage', feePercentage.toString());
    }
    try {
        const response = await axios.get(url, { params });
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            const message = error.response?.data?.message;
            if (message) {
                throw new PortalsError(message);
            }
            throw new Error(`Failed to fetch Portals trade order: ${error.message}`);
        }
        throw error;
    }
};
export const fetchPortalsTradeEstimate = async ({ inputToken, inputAmount, outputToken, slippageTolerancePercentage, swapperConfig, }) => {
    const url = `${swapperConfig.VITE_PORTALS_BASE_URL}/v2/portal/estimate`;
    const params = new URLSearchParams({
        inputToken,
        inputAmount,
        outputToken,
    });
    if (slippageTolerancePercentage !== undefined) {
        params.append('slippageTolerancePercentage', slippageTolerancePercentage.toFixed(2)); // Portals API expects a string with at most 2 decimal places
    }
    try {
        const response = await axios.get(url, { params });
        return response.data;
    }
    catch (error) {
        if (axios.isAxiosError(error)) {
            throw new Error(`Failed to fetch Portals trade estimate: ${error.message}`);
        }
        throw error;
    }
};
